<app-nexleader-currency
  *ngIf="!isLoading()"
  [currencyQuantity]="getCurrencyQuantity()"
  [currencyCode]="getCurrencyCode()"
  [overrideFractionSize]="0"
></app-nexleader-currency>
